import React from 'react'
import styles from './styles.module.scss'
import Avatar from 'srcReact/components/common2/Avatar'
import { formatLastUpdateDate } from 'srcReact/helpers/datetimeHelper'
import { useTranslation } from 'react-i18next'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { useDispatch } from 'react-redux'

function UserList({ users, showTime = false, renderAction, loggedInUser, onlyEmail = false }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const showUserLightModal = (modalUser) => {
    const lp = new LightProfileProto()
    lp.userId = modalUser.id || modalUser.user_id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }
  return (
    <div className={styles.list}>
      {users.map((user, index) => {
        const userInfo = user.user_info
        return userInfo ? (
          <div key={`${userInfo.id}_${index}`} className={styles.listItem}>
            <div className={styles.left}>
              <Avatar
                userId={userInfo.id}
                profilePicture={userInfo.profile_picture_data.profile_picture}
                imgWrapperSize='xsmall'
                mimeType={userInfo.profile_picture_data.mime_type}
                originalTag={userInfo.profile_picture_data.original_tag}
                isOriginal={userInfo.profile_picture_data.is_original}
                onClickAction={() => showUserLightModal(userInfo)}
                withExpertiseGroup={userInfo.with_expertise_group}
              />
              <div className={styles.user}>
                {showTime && (
                  <p className={styles.time}>
                    {formatLastUpdateDate(userInfo.last_invitation_date || user.date_time, '', t)}
                  </p>
                )}
                {onlyEmail ? (
                  <p className={styles.email}>{user.value}</p>
                ) : (
                  <button
                    type='button'
                    className={styles.name}
                    onClick={() => {
                      showUserLightModal(userInfo)
                    }}>
                    {userInfo.firstname} {userInfo.lastname}
                  </button>
                )}
              </div>
            </div>
            <div className={styles.right}>
              {renderAction &&
                userInfo.id !== loggedInUser?.id &&
                renderAction(onlyEmail ? { email: user.value } : userInfo)}
            </div>
          </div>
        ) : null
      })}
    </div>
  )
}

export default UserList
